import { FC, PropsWithChildren } from 'react'
import './AppFormCell.css'

export const AppFormCell: FC<
    PropsWithChildren<
        React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>> = ({ children, ...props }) => (
    <div className='app-form-cell' { ...props } >{ children }</div>
);
